import React, {Component} from 'react';
import axios from 'axios';
import Fingerprintjs2 from 'fingerprintjs2';
import RiskOtpLogin from './RiskOtpLogin';
import SpecificOtpLogin from './SpecificOtpLogin'
import Login from './Login';
import { Base64 } from 'js-base64'

const initialState = {
  screen: '',
  resAuthenticated: '',
  fingerPrint: '',
  errorMap: null,
  loading : false,
  autoLoginStateFlg: false,
  autoLoginId: '',
  maskmail: '',
  snsHidden: false,
  webViewFlag: false,
  maskphonenumber: '',
  tabChangeFlg: false,
  webAuthnFlg: true,
  dispPassKeyFlg: false,
  fillinId: ''
}

class CommonLogin extends Component {

  state = initialState;

  // 初期表示処理
  componentDidMount () {

    // ブラウザバックから遷移する場合
    if (window.performance.navigation.type === 2) {
      // セッションストレージにSNSログイン情報を削除する
      if (sessionStorage.getItem('SNSLOGIN')) {
        sessionStorage.removeItem('SNSLOGIN')
      }
      // エラー画面に遷移し、処理を終了する
      this.props.history.push({
        pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`,
        state:{errorScreen: 'BACKWARD_BUTTON_CLICKED'}
      });          
    }
    // 正常遷移の場合
    else{

      const { AUTH_TYPE, AUTHENTICATED } = this.props.params;
      const info = {
          AUTH_TYPE: AUTH_TYPE
      }

      // AUTH_TYPEが「AUTH_SOCIAL_JOIN」の場合、エラー画面を表示
      if ( AUTH_TYPE === process.env.REACT_APP_AUTH_TYPE_JOIN ){
        this.props.history.push({
          pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
        });
      } else {
        // ログイン後にSNS認証紐付け確認画面に遷移する場合
        // SNSログインボタンは表示しない
        if ( AUTHENTICATED && window.endsWith(AUTHENTICATED, '/sns_relation')) {
          this.setState({ snsHidden: true });
        }     

        var userAgent = window.navigator.userAgent.toLowerCase();    
        if(userAgent.indexOf('trident') !== -1 || userAgent.indexOf('msie') !== -1) {
          import('url-search-params-polyfill').then(() => {
            // フィンガープリント取得
            let options = {excludes: {userAgent: true, enumerateDevices: true, pixelRatio: true, doNotTrack: true, fontsFlash: true}};
            Fingerprintjs2.getV18( options, (result)=>{
              this.setState({ fingerPrint: result });
              // 取得後にlogin前処理呼出し
              this.beforeLogin(info);
            });
          });
        }
        else {
          // フィンガープリント取得
          let options = {excludes: {userAgent: true, enumerateDevices: true, pixelRatio: true, doNotTrack: true, fontsFlash: true}};
          Fingerprintjs2.getV18( options, (result)=>{
            this.setState({ fingerPrint: result });
            // 取得後にlogin前処理呼出し
            this.beforeLogin(info);
          });
        }

        // WebViewから呼び出された場合にはGoogleでログインボタンを非表示とする
        let winUserAgent = window.navigator.userAgent
        let userAgentExcludeList = process.env.REACT_APP_USERAGENT_EXCLUDE_LIST.split(',');
        for (let data of userAgentExcludeList) {
          if (winUserAgent.indexOf(data) !== -1) {
            this.setState({ webViewFlag: true, webAuthnFlg: false });
            break;
          } 
        }
        
        // WebAuthn対応有無確認
        if (!(typeof window.PublicKeyCredential === 'function')) {
          this.setState({
            webAuthnFlg: false
          })
        }
      }
    }
  }

  // login前処理
  beforeLogin = (info) => {

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    const { fingerPrint } = this.state;
    const { SITE_ID, AUTHENTICATED, MESSAGE_AUTH} = this.props.params;
    const { AUTH_TYPE, snsid, ACTION_TOKEN, SESSION_TOKEN, fillinId, LowLevelSessionFlg, Fs2AuthenticationRequest, changeAuthTypeFlg} = info;

    try {
      // tidクリア
      document.cookie = String(`${process.env.REACT_APP_COOKIE_KEY_TID}=;max-age=0;domain=${process.env.REACT_APP_COOKIE_DOMAIN};path=${process.env.REACT_APP_COOKIE_PATH};`);

      if(changeAuthTypeFlg){
        this.setState({ dispPassKeyFlg: true });
      }

      // パラメータ作成
      const params = new URLSearchParams();
      params.append('AUTH_TYPE',  AUTH_TYPE);
      params.append('SITE_ID', SITE_ID);
      params.append('MESSAGE_AUTH', MESSAGE_AUTH);
      params.append('AUTHENTICATED', AUTHENTICATED);
      params.append('snsid', snsid);
      params.append('Fingerprint', fingerPrint);
      // SNSログインの場合、アクショントークンを設定
      if(AUTH_TYPE === process.env.REACT_APP_AUTH_TYPE){
        ACTION_TOKEN && params.append('action_token', ACTION_TOKEN);
        SESSION_TOKEN && params.append('session_token', SESSION_TOKEN);
      }
      // 認証方式が「AUTH_FS2」の場合、FS2認証リクエスト要求を設定
      if(AUTH_TYPE === process.env.REACT_APP_AUTH_FS2){
        params.append('Fs2AuthenticationRequest', Fs2AuthenticationRequest);
      }

      // ローディング開始
      this.setState({ loading: true });

      // 認証要求
      axios({
              method: 'POST',
              url: process.env.REACT_APP_URL_CO_SC_API_LOGIN,
              data: params,
              headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                        'Cache-Control': 'no-store',
                        'Pragma': 'no-cache'}
            })       
        .then( response => {
          const resultCode = response.data.resultCode;
          const authType = response.data.authType;
          const authenticated = response.data.authenticated;
          const error_message = response.data.error_message;
          const maskmail = response.data.maskmail;
          const maskphonenumber = response.data.maskphonenumber;
          const Fs2AuthenticationRequest = response.data.Fs2AuthenticationRequest;
          if (resultCode){    
            // ログイン画面表示 or 次認証あり
            if (resultCode==='CO-SC0001' || resultCode==='CO-SC0002'){
              if (authType){
                if (authType === 'AUTH_THREEKEY' || authType === 'AUTH_THREEKEY_LOW') {
                  // オートログイン認証を行う
                    this.autoLogin();
                    // パスキー認証表示判定処理を行う
                    const dispPassKeyFlg = this.getDispPassKeyFlg(changeAuthTypeFlg);
                    // stateに設定する
                    if (changeAuthTypeFlg){
                      this.setState({
                        dispPassKeyFlg: dispPassKeyFlg, 
                        fillinId: fillinId
                      });
                    } else {
                      this.setState({
                        dispPassKeyFlg: dispPassKeyFlg
                      });
                    }

                    // 「GA計測用データレイヤースクリプト追加処理」を呼出す
                    if (this.state.snsHidden) {
                      if (dispPassKeyFlg){
                        window.addDataLayerScript('jmbauth_login_passkey');
                      }else{
                        window.addDataLayerScript('jmbauth_login');
                      }
                    }
                    else {
                      window.addDataLayerScript('jmbauth_login_sns');
                    }
                }
                else if(authType==='AUTH_SOCIAL'){
                  const redirecturi = response.data.redirecturi;
                  if(snsid === 'line'){
                    this.setState({
                      loading: false,
                      tabChangeFlg: true
                    });
                  }
                  window.location.href = redirecturi;
                }
                else if(authType === process.env.REACT_APP_AUTH_FS2){
                  this.certifyPasskey(Fs2AuthenticationRequest)
                    .then((fs2AuthenticationResponse) => {
                      const param = {
                        passkeyCertifyFlg: true,
                        ACTION_TOKEN: ACTION_TOKEN,
                        SESSION_TOKEN: SESSION_TOKEN,
                        Fs2AuthenticationResponse: fs2AuthenticationResponse,
                        LowLevelSessionFlg: LowLevelSessionFlg
                      } 
                      this.commonLogin(param);
                    })
                    .catch((error) => {
                      const isDebug = process.env.REACT_APP_DEBUG_ERRORLOG === 'true';

                      if (error.message === 'timeout') {
                        this.setState({
                          errorMap: isDebug
                            ?{ ERROR: messageList.login.M082_errorMessage011 + '(' + error.message + ')' }
                            :{ ERROR: messageList.login.M082_errorMessage011 },
                          loading: false
                        });
                      } else if(error.name === 'NotAllowedError'){
                        this.setState({
                          errorMap:  isDebug
                            ?{ ERROR: messageList.login.M090_errorMessage013 + '(' + error.name + ')' }
                            :{ ERROR: messageList.login.M090_errorMessage013 },
                          loading: false
                        });
                      } else {
                        this.setState({
                          errorMap:  isDebug
                            ?{ ERROR: messageList.login.M089_errorMessage012 + '(' + error.name + ')' }
                            :{ ERROR: messageList.login.M089_errorMessage012 },
                          loading: false
                        });
                      }
                      // エラーメッセージ表示領域に遷移する
                      window.location="#JS_error";
                    })
                }
                else {
                  this.setState({ screen: authType, 
                    errorMap: '',
                    loading: false,
                    maskmail: maskmail,
                    maskphonenumber: maskphonenumber
                  });
                }  
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.login.M025_errorMessage002 },
                  loading: false
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";  
              }
            }
            // 全認証終了
            else if (resultCode==='CO-SC0003'){
              if (authenticated){
                // 遷移先URLに遷移し、処理を終了する
                window.location.href = authenticated;
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.login.M025_errorMessage002 },
                  loading: false
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";  
              }
            }
            // 利用者のワンタイムパスワード通知先が登録されていない
            else if (resultCode==='CS-AT1021'){
              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`,
                state:{errorScreen: 'ADDRESS_UNREGISTERED_OTPLOGIN'}
              });
            }
            // CO-AT5000が返却された場合
            else if (resultCode==='CO-AT5000'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M034_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT5005が返却された場合
            else if (resultCode==='CO-AT5005'){
              // UserIdentifiedKeyIsNotMatchExceptionの文字列が含まれる場合
              if (error_message && error_message.indexOf('UserIdentifiedKeyIsNotMatchException') !== -1){
                // エラー一覧で定義したシステムエラーを返却する
                this.setState({ errorMap:
                  { ERROR: messageList.login.M039_errorMessage008},
                  loading: false
                });
              }
              else if (error_message && error_message.indexOf('RecordNotFoundException') !== -1){
                // エラー一覧で定義したシステムエラーを返却する
                this.setState({ errorMap:
                  { ERROR: messageList.login.M081_errorMessage010},
                  loading: false
                });
              }
              else {
                // エラー一覧で定義したシステムエラーを返却する
                this.setState({ errorMap:
                  { ERROR: messageList.login.M035_errorMessage004 },
                  loading: false
                });
              }
              
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT3000が返却された場合
            else if (resultCode==='CO-AT3000'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M036_errorMessage005 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT5001が返却された場合
            else if (resultCode==='CO-AT5001'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M037_errorMessage006 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT5004が返却された場合
            else if (resultCode==='CO-AT5004'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M038_errorMessage007 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT6008が返却された場合
            else if (resultCode==='CO-AT6008' && this.state.screen !== 'AUTH_RISK_ONETIME' && this.state.screen !== 'AUTH_ONETIME' && this.state.screen !== 'AUTH_SMS_ONETIME'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M052_errorMessage009 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CS-AT1031が返却された場合
            else if (resultCode==='CS-AT1031'){
              // 操作拒否エラー画面に遷移する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/deny_error`,
              });
            }
            // CS-AT1032が返却された場合
            else if (resultCode==='CS-AT1032'){
              // 携帯電話番号登録導線画面に遷移する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_register_guide`,
              });
            }
            else{
              let errorMessageStr;
              errorMessageStr = error_message;
              // CO-AT3100の場合、Exceptionの文字列をブランクに置き換える
              if (resultCode==='CO-AT3100' && errorMessageStr){
                errorMessageStr = errorMessageStr
                    .replace('jp.co.nec.nc7000_3a.co.authn.exception.CompositeAuthnPluginFailedException: jp.co.nec.nc7000_3a.co.authn.exception.AuthenticationPluginFailedException:', '')
              }

              if(authType){
                if (errorMessageStr){
                  this.setState({ screen: authType, 
                                  errorMap: { ERROR: errorMessageStr },
                                  loading: false
                  });
                }
                else{
                  this.setState({ screen: authType, 
                    errorMap:
                    { ERROR: messageList.login.M025_errorMessage002 },
                    loading: false
                  });                    
                }
              }
              else{
                if (errorMessageStr){
                  this.setState({ errorMap:
                    { ERROR: errorMessageStr },
                    loading: false
                  });
                }
                else {
                  this.setState({ errorMap:
                    { ERROR: messageList.login.M025_errorMessage002 },
                    loading: false
                  });
                }
              }
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else{
            this.setState({ errorMap:
              { ERROR: messageList.login.M025_errorMessage002 },
              loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.login.M025_errorMessage002 },
                loading: false

              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.login.M025_errorMessage002 },
                loading: false
              });
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.login.M025_errorMessage002 },
              loading: false
            });
        }
        // エラーメッセージ表示領域に遷移する
        window.location="#JS_error";
      })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.login.M025_errorMessage002},
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }
  }

  // オートログイン認証
  autoLogin = () => {

    try {
      // オートログイン認証セッションCookieチェックAPI
      axios({
            method: 'GET',
            url: process.env.REACT_APP_URL_CO_SC_API_CHECKAUTOSESSION,
            data: null,
            headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                      'Cache-Control': 'no-store',
                      'Pragma': 'no-cache'}
          }) 
        .then ( response => {         
          this.setState({ screen: 'AUTH_THREEKEY',
                          autoLoginId: response.data[0].id,
                          autoLoginStateFlg: true,
                          errorMap: '',
                          loading: false
                        });
        })
        .catch( error => {
          this.setState({ 
            screen: 'AUTH_THREEKEY',
            errorMap: '',
            loading: false
          });
        })
    } catch( err ) {
      this.setState({ 
        screen: 'AUTH_THREEKEY',
        errorMap: '',
        loading: false
      });
    } finally {
    }
  }

  // [ログイン]ボタン押下時処理
  commonLogin  = (info) => {
    const { fingerPrint } = this.state;
    const { ORG_ID, ID, PWD, LowLevelSessionFlg, ACTION_TOKEN, SESSION_TOKEN, passkeyCertifyFlg, Fs2AuthenticationResponse } = info;   

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (this.state.screen === 'AUTH_RISK_ONETIME' || this.state.screen === 'AUTH_ONETIME' || this.state.screen === 'AUTH_SMS_ONETIME') {
      if (PWD === '') {
        this.setState({ errorMap: { ERROR: messageList.otpLogin.M014_errorMessage001, errorId: 'otp'}});
        // エラーメッセージ表示領域に遷移する
        window.location="#JS_error";
        return;
      }
    }
    else if(!passkeyCertifyFlg){
      if (ID === '') {
        this.setState({ errorMap: { ERROR: messageList.login.M024_errorMessage001, errorId: 'id' } });
        // エラーメッセージ表示領域に遷移する
        window.location = "#JS_error";
        return;
      }

      if (PWD === '') {
        this.setState({ errorMap: { ERROR: messageList.login.M024_errorMessage001, errorId: 'password' } });
        // エラーメッセージ表示領域に遷移する
        window.location = "#JS_error";
        return;
      }
    }

    // ログイン要求を行う
    try {
      // パラメータ作成
      const params = new URLSearchParams();
      if(passkeyCertifyFlg){
        params.append('Fingerprint', fingerPrint);
        ACTION_TOKEN && params.append('action_token', ACTION_TOKEN);
        SESSION_TOKEN && params.append('session_token', SESSION_TOKEN);
        params.append('Fs2AuthenticationResponse', Fs2AuthenticationResponse);
        params.append('lowLevelSessionFlg', LowLevelSessionFlg);
      }
      else{
        params.append('ORG_ID', ORG_ID);
        // お得意様番号が7桁の場合は先頭に00でパディングして9桁で送信する
        if (ID && ID.length === 7) {
          params.append('ID', ID.padStart(9, '00'));
        }
        else {
          params.append('ID', ID);
        }
        params.append('PWD', PWD);
        params.append('Fingerprint', fingerPrint);
        params.append('lowLevelSessionFlg', LowLevelSessionFlg);
        ACTION_TOKEN && params.append('action_token', ACTION_TOKEN);
        SESSION_TOKEN && params.append('session_token', SESSION_TOKEN);
      }

      // ローディング開始
      this.setState({ loading: true });
      
      // 認証メイン処理
      axios({
              method: 'POST',
              url: process.env.REACT_APP_URL_CO_SC_API_LOGIN,
              data: params,
              headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                        'Cache-Control': 'no-store',
                        'Pragma': 'no-cache'}
            }) 
        .then( response => {
          const resultCode = response.data.resultCode;
          const authenticated = response.data.authenticated;
          const authType = response.data.authType; 
          const error_message = response.data.error_message;        
          const maskmail = response.data.maskmail;
          const maskphonenumber = response.data.maskphonenumber;
          
          if (resultCode){
            // ログイン画面表示 or 次認証あり
            if (resultCode==='CO-SC0001' || resultCode==='CO-SC0002'){
              if (authType){
                if (authType !== 'AUTH_RISK_ONETIME' && authType !== 'AUTH_ONETIME' && authType !== 'AUTH_SMS_ONETIME'){
                  this.saveAuthType(passkeyCertifyFlg);
                }
                this.setState({ screen: authType,
                                errorMap: '',
                                loading: false,
                                maskmail: maskmail,
                                maskphonenumber: maskphonenumber
                              });                
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.login.M025_errorMessage002 },
                  loading: false
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";  
              }
            }
            // 全認証終了
            else if (resultCode==='CO-SC0003'){
              if (authenticated){
                // 遷移元画面がOTP認証以外の場合のみ、判定を実施
                if (this.state.screen !== 'AUTH_RISK_ONETIME' && this.state.screen !== 'AUTH_ONETIME' && this.state.screen !== 'AUTH_SMS_ONETIME') {
                  if (authType !== 'AUTH_RISK_ONETIME' && authType !== 'AUTH_ONETIME' && authType !== 'AUTH_SMS_ONETIME'){
                    this.saveAuthType(passkeyCertifyFlg);
                  }
                }
                // 遷移先URLに遷移し、処理を終了する
                window.location.href = authenticated;
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.login.M025_errorMessage002 },
                  loading: false
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";  
              }
            }
            // 利用者のワンタイムパスワード通知先が登録されていない
            else if (resultCode==='CS-AT1021'){
              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`,
                state:{errorScreen: 'ADDRESS_UNREGISTERED_OTPLOGIN'}
              });
            }
            // CO-AT5000が返却された場合
            else if (resultCode==='CO-AT5000'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M034_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT5005が返却された場合
            else if (resultCode==='CO-AT5005'){
              // UserIdentifiedKeyIsNotMatchExceptionの文字列が含まれる場合
              if (error_message && error_message.indexOf('UserIdentifiedKeyIsNotMatchException') !== -1){
                // エラー一覧で定義したシステムエラーを返却する
                this.setState({ errorMap:
                  { ERROR: messageList.login.M039_errorMessage008 },
                  loading: false
                });
              }
              else if (error_message && error_message.indexOf('RecordNotFoundException') !== -1){
                // エラー一覧で定義したシステムエラーを返却する
                this.setState({ errorMap:
                  { ERROR: messageList.login.M081_errorMessage010 },
                  loading: false
                });
              }
              else {
                // エラー一覧で定義したシステムエラーを返却する
                this.setState({ errorMap:
                  { ERROR: messageList.login.M035_errorMessage004 },
                  loading: false
                });
              }
              
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT3000が返却された場合
            else if (resultCode==='CO-AT3000'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M036_errorMessage005 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT5001が返却された場合
            else if (resultCode==='CO-AT5001'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M037_errorMessage006 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT5004が返却された場合
            else if (resultCode==='CO-AT5004'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M038_errorMessage007 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CO-AT6008が返却された場合
            else if (resultCode==='CO-AT6008' && this.state.screen !== 'AUTH_RISK_ONETIME' && this.state.screen !== 'AUTH_ONETIME' && this.state.screen !== 'AUTH_SMS_ONETIME'){
              // エラー一覧で定義したシステムエラーを返却する
              this.setState({ errorMap:
                { ERROR: messageList.login.M052_errorMessage009 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            // CS-AT1031が返却された場合
            else if (resultCode==='CS-AT1031'){
              // 操作拒否エラー画面に遷移する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/deny_error`,
              });
            }
            // CS-AT1032が返却された場合
            else if (resultCode==='CS-AT1032'){
              // 携帯電話番号登録導線画面に遷移する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_register_guide`,
              });
            }
            else{
              let errorMessageStr;
              errorMessageStr = error_message;
              // CO-AT3100の場合、Exceptionの文字列をブランクに置き換える
              if (resultCode==='CO-AT3100' && errorMessageStr){
                errorMessageStr = errorMessageStr
                    .replace('jp.co.nec.nc7000_3a.co.authn.exception.CompositeAuthnPluginFailedException: jp.co.nec.nc7000_3a.co.authn.exception.AuthenticationPluginFailedException:', '')
              }

              if (errorMessageStr){
                this.setState({ errorMap:
                  { ERROR: errorMessageStr },
                  loading: false
                });
              }
              else {
                this.setState({ errorMap:
                  { ERROR: messageList.login.M025_errorMessage002 },
                  loading: false
                });
              }
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else if ( response.request.responseURL && response.request.responseURL.indexOf('CO-AT3100') !== -1){
            // エラー画面に遷移し、処理を終了する
            window.location.href = response.request.responseURL;
          }
          else{
            this.setState({ errorMap:
              { ERROR: messageList.login.M025_errorMessage002 },
              loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.login.M025_errorMessage002 },
                loading: false
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.login.M025_errorMessage002 },
                loading: false
              });
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.login.M025_errorMessage002 },
              loading: false
            });
          }
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        });
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.login.M025_errorMessage002},
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }
  }

  // [ログアウト]ボタン押下時処理
  logout = () => {

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    try {
      // パラメータ作成
      const params = new URLSearchParams();
      params.append('design', sessionStorage.getItem('design'));
      params.append('lang', sessionStorage.getItem('lang'));

      // ローディング開始
      this.setState({ loading: true });

      // ログアウトAPI
      axios({
              method: 'POST',
              url: process.env.REACT_APP_URL_CO_SC_API_LOGOUT,
              data: params,
              headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                        'Cache-Control': 'no-store',
                        'Pragma': 'no-cache'}
            }) 
        .then(response => {
          window.location.href = response.request.responseURL || process.env.REACT_APP_LOGOUT_URL + response.config.data;
        })
        .catch(error => {
          console.error(error);
          if ( error.response ) {
            this.setState({ errorMap:
              { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.login.M025_errorMessage002 },
              loading: false
            });
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.login.M025_errorMessage002 },
              loading: false
            });
          }
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.login.M025_errorMessage002},
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }
  }

  // 認証方式保存処理
  saveAuthType = (passkeyCertifyFlg) => {
    // 引数の認証方式を判定し、認証方式を設定する
    let authMethod;
    if(passkeyCertifyFlg){
      authMethod = 'pk';
    } else {
      authMethod = 'ip';
    }

    // ローカルストレージに前回ログイン方式を設定する
    localStorage.setItem('LASTAUTHMETHOD', authMethod);

    // 現在日時取得
    const d = new Date()
    const pad = (n) => n.toString().padStart(2, '0')
    const timestamp = [
      d.getFullYear(),
      pad(d.getMonth() + 1),
      pad(d.getDate()),
      pad(d.getHours()),
      pad(d.getMinutes()),
      pad(d.getSeconds())
    ].join('')
    
    // ログイン認証方式をCookieに保存する
    const jalloginip = authMethod + '_' + timestamp;
    document.cookie = String(`jalloginip=${jalloginip};domain=${process.env.REACT_APP_COOKIE_DOMAIN};path=${process.env.REACT_APP_COOKIE_PATH};secure;samesite=lax`);
  }

  // パスキー認証処理
  certifyPasskey = (Fs2AuthenticationResponse) => {

    return new Promise((resolve, reject) => {
      // パース処理
      const Fs2AuthenticationResponseOptions = JSON.parse(Fs2AuthenticationResponse)
      
      // 変換処理
      Fs2AuthenticationResponseOptions.challenge = Base64.toUint8Array(Fs2AuthenticationResponseOptions.challenge).buffer
      if (Fs2AuthenticationResponseOptions.allowCredentials !== undefined) {
        Fs2AuthenticationResponseOptions.allowCredentials.forEach((listItem) => {
          listItem.id = Base64.toUint8Array(listItem.id).buffer
        })
      }

      // timeoutの値を受け取る
      const timeout = Fs2AuthenticationResponseOptions.timeout + 3000
      
      // 認証器の処理
      navigator.credentials
        .get({ publicKey: Fs2AuthenticationResponseOptions })
        .then((assertedCredential) => {
          const authData = new Uint8Array(assertedCredential.response.authenticatorData)
          const clientDataJSON = new Uint8Array(assertedCredential.response.clientDataJSON)
          const rawId = new Uint8Array(assertedCredential.rawId)
          const sig = new Uint8Array(assertedCredential.response.signature)

          const response = {
            authenticatorData: Base64.fromUint8Array(authData, true),
            clientDataJSON: Base64.fromUint8Array(clientDataJSON, true),
            signature: Base64.fromUint8Array(sig, true),
          }

          if (assertedCredential.response.userHandle !== undefined) {
            const userHandle = new Uint8Array(assertedCredential.response.userHandle)
            response.userHandle = Base64.fromUint8Array(userHandle, true)
          }

          const fs2AuthenticationResponse = {
            id: assertedCredential.id,
            rawId: Base64.fromUint8Array(rawId, true),
            response: response,
          }
          resolve(JSON.stringify(fs2AuthenticationResponse))
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        })
        .finally(() => {
          clearTimeout(timeoutId)
        })

      const timeoutId = setTimeout(() => {
        const error = new Error('timeout');
        reject(error);
      }, timeout)
    })
  }

  // パスキー認証表示判定処理
  getDispPassKeyFlg = (changeAuthTypeFlg) => {
    const design = sessionStorage.getItem('design');
    if (design==="JH001N" || design==="JH004N"){
      return false;
    }
    if (changeAuthTypeFlg){
      return false;
    } else {
      // ローカルストレージから前回ログイン方式（LASTAUTHMETHOD）を取得する
      const lastAuthmethod = localStorage.getItem('LASTAUTHMETHOD');
      if (lastAuthmethod === 'pk'){
        return true;
      } else {
        return false;
      }
    }
  }

  // 画面表示処理
  render() {

    // リスクベースOTP入力画面
    if (this.state.screen === 'AUTH_RISK_ONETIME'){
      return (
        <RiskOtpLogin loginMethod={this.commonLogin}
                      errMap={this.state.errorMap}
                      loading={this.state.loading}
                      maskmail={this.state.maskmail}
                      maskphonenumber={this.state.maskphonenumber}/>
      );
    }
    // 特定サービスOTP入力画面
    else if (this.state.screen === 'AUTH_ONETIME' || this.state.screen === 'AUTH_SMS_ONETIME'){
      return (
        <SpecificOtpLogin loginMethod={this.commonLogin}
                          errMap={this.state.errorMap}
                          loading={this.state.loading}
                          maskmail={this.state.maskmail}
                          maskphonenumber={this.state.maskphonenumber}/>
      );
    }
    // ログイン画面
    else if (this.state.screen === 'AUTH_THREEKEY' || this.state.screen === 'AUTH_THREEKEY_LOW' || (this.state.errorMap && this.state.errorMap.ERROR)) {
      if(!this.state.screen){
        this.setState({ screen: 'AUTH_THREEKEY' });
      }
      return (
        <Login loginMethod={this.commonLogin} 
               errMap={this.state.errorMap}
               loading={this.state.loading}
               autoLoginId={this.state.autoLoginId} 
               autoLoginStateFlg={this.state.autoLoginStateFlg}
               guestUrl={this.props.params.GUEST_URL}
               logoutMethod={this.logout}
               snslogin={this.beforeLogin}
               snsHidden={this.state.snsHidden}
               webViewFlag={this.state.webViewFlag}
               tabChangeFlg={this.state.tabChangeFlg}
               dispPassKeyFlg={this.state.dispPassKeyFlg}
               fillinId={this.state.fillinId}
               webAuthnFlg={this.state.webAuthnFlg}/>
      );
    }
    // 空白のロード画面
    else {
      return(
        <section className="section">
          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
          }
        </section>
      );
    }      
  }
}

export default CommonLogin